import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import FinesPayPageRoute from './pay/FinesPayPageRoute';
import FinesPageRoute from './FinesPageRoute';

const basePath = '/v2/fines';

// A pathless layout route. The v5 shape had `/v2/fines/pay` nested under `/v2/fines/:slug`, which
// v6 rejects -- an absolute child path must literally start with the combined parent path, and
// `/v2/fines/pay` does not start with `/v2/fines/:slug`. Hoisting both to absolute siblings under a
// layout preserves the behaviour: /v2/fines/pay renders the pay page, any other slug renders the
// error page, and bare /v2/fines falls through to the default export below.
export const finesSubroutes = (
  <Route
    element={
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    }
  >
    <Route path={`${basePath}/pay/*`} element={<FinesPayPageRoute />} />
    <Route path={`${basePath}/:slug/*`} element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);

export default (
  <Route
    path={`${basePath}/*`}
    element={
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <MainLayout deprecated>
            <BorrowingLayout>
              <FinesPageRoute />
            </BorrowingLayout>
          </MainLayout>
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    }
  />
);
